export default __webpack_public_path__ + "static/media/1528.71cfd0dc.png";